<template>
    <div v-if="post" class="left">


        <div class="dx-fieldset">
            <div class="dx-field">
                <div class="dx-field-label">ID:</div>
                <div class="dx-field-value">
                    <DxTextBox :value='post.EloId' :readOnly="true" />
                </div>

            </div>
            <div class="dx-field">
                <div class="dx-field-label">Level:</div>
                <div class="dx-field-value">
                    <DxTextBox :value='post.EloLevel' readOnly="true" />
                </div>

            </div>
            <div class="dx-field">
                <div class="dx-field-label">Date:</div>
                <div class="dx-field-value">
                    <DxDateBox :value='post.EloDate' :readOnly="true" type="datetime" />
                </div>

            </div>

            <div class="dx-field">
                <div class="dx-field-label">Thread:</div>
                <div class="dx-field-value">
                    <DxTextBox :value='post.EloThread' :readOnly="true" />
                </div>
            </div>


            <div class="dx-field">
                <div class="dx-field-label">Logger:</div>
                <div class="dx-field-value">
                    <DxTextBox :value='post.EloLogger' :readOnly="true" />
                </div>
            </div>

            <div class="dx-field">
                <div class="dx-field-label">Message:</div>
                <div class="dx-field-value">
                    <DxTextArea :height="100"
                                :value='post.EloMessage' :readOnly="true" />
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label">Value:</div>
                <div class="dx-field-value">
                    <DxTextArea :height="500"
                                :width="500"
                                :value='post.EloException' :readOnly="true" />
                </div>
            </div>

            <div class="buttons buttons-demo">
                <div>
                    <div class="buttons-column">


                        <div class=" btnBlock">
                            <DxButton :width="120"
                                      text="Cancel"
                                      type="default"
                                      @click="onClick($event)" />
                        </div>
                        <div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import { DxTextBox, DxTextArea } from 'devextreme-vue';
    import { DxButton } from 'devextreme-vue/button';
    import { DxDateBox } from 'devextreme-vue/date-box';
    import $ from 'jquery';

    const baseUri = "WebApi.asmx/api/EventLogListService";
    export default {
        name: 'EventLogListDetail',
        components: {

            DxButton,
            DxTextBox,
            DxTextArea,
            DxDateBox,

        },
        data() {
            return {
                post: null,
            };
        },
        created: function () {
            axios
                .get(baseUri + '/GetDetail')
                .then(res => {
                    this.post = res.data.data
                })
        },
        methods: {
            onClick() {
                $("form").attr("action", window.location.pathname + "?action=cancel").submit();
            }
        }
    }


</script>
<style>

    div {
        text-align: left;
    }

    .options {
        margin-top: 20px;
        padding: 20px;
        background-color: rgba(191, 191, 191, 0.15);
        box-sizing: border-box;
        width: 100%;
    }
</style>
